// extracted by css-extract-rspack-plugin
export default {"clickableLabel":"SignedCommitBadge-module__clickableLabel__seodh"};